import React from 'react';
const CART_URL = 'https://mujeresempoderadas.lat/cart/add?id=52459756126507&quantity=1';
export function WhatYouGet() {
  return <section className="w-full" style={{
    background: 'var(--bg-page)'
  }} aria-label="Qué incluye" data-id="element-366">
      <div className="max-w-2xl mx-auto px-4 py-10 md:py-16" data-id="element-367">
        <div className="section-accent" data-id="element-368" />
        <p className="eyebrow text-center mb-3" data-id="element-369">Qué incluye</p>
        <h2 className="text-2xl md:text-3xl text-center mb-8" style={{
        fontFamily: 'var(--font-heading)',
        fontWeight: 600,
        color: 'var(--text-primary)',
        letterSpacing: '-0.02em'
      }} data-id="element-370">
          Todo lo que viene dentro del{' '}
          <span style={{
          color: 'var(--color-gold)'
        }} data-id="element-371">
            Sistema 10x2™
          </span>
        </h2>

        <div className="space-y-4 mb-8" data-id="element-372">
          {/* Feature 1 */}
          <div className="feature-card overflow-hidden flex flex-col p-0" style={{
          borderRadius: '1rem'
        }} data-id="element-373">
            {/* Image area */}
            <div className="w-full overflow-hidden" style={{
            borderRadius: '1rem 1rem 0 0'
          }} aria-label="Imagen módulo 1" data-id="element-374">
              <img src="https://cdn.magicpatterns.com/uploads/97MnpMEkKTzrRnKqTXPHsu/20260303_0934_Image_Generation_simple_compose_01kjsv0b1sepf8r9q7dfd9egx5_(1).webp" alt="Sistema 10x2™ — El Método Express, Cocina por Bloques" className="w-full object-cover" style={{
              display: 'block',
              maxHeight: '200px',
              objectPosition: 'center'
            }} data-id="element-375" />
            </div>
            {/* Content */}
            <div className="p-5" data-id="element-376">
              <h3 className="text-base mb-1.5" style={{
              fontFamily: 'var(--font-heading)',
              fontWeight: 600,
              color: 'var(--text-primary)',
              letterSpacing: '-0.01em'
            }} data-id="element-377">
                Cocina por Bloques — Paso a Paso
              </h3>
              <p className="text-sm leading-relaxed m-0" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-secondary)'
            }} data-id="element-378">
                Instrucciones de la A a la Z que te llevan de la mano.{' '}
                <strong data-id="element-379">
                  Cocinás TODO en 2 horas y tenés 10 días resueltos.
                </strong>{' '}
                <em data-id="element-380">Es como tener un chef organizador a tu lado.</em>
              </p>
            </div>
          </div>

          {/* Feature 2 */}
          <div className="feature-card overflow-hidden flex flex-col p-0" style={{
          borderRadius: '1rem'
        }} data-id="element-381">
            {/* Image area */}
            <div className="w-full overflow-hidden" style={{
            borderRadius: '1rem 1rem 0 0'
          }} aria-label="Imagen módulo 2" data-id="element-382">
              <img src="https://cdn.magicpatterns.com/uploads/uf32JNbHTXhz6ppeGb7Tug/20260303_0937_Image_Generation_simple_compose_01kjsv781fffarrc14zxyvvc0m_(1).webp" alt="Sistema 10x2™ — Listas de Compra Exactas" className="w-full object-cover" style={{
              display: 'block',
              maxHeight: '200px',
              objectPosition: 'center'
            }} data-id="element-383" />
            </div>
            {/* Content */}
            <div className="p-5" data-id="element-384">
              <h3 className="text-base mb-1.5" style={{
              fontFamily: 'var(--font-heading)',
              fontWeight: 600,
              color: 'var(--text-primary)',
              letterSpacing: '-0.01em'
            }} data-id="element-385">
                Listas de Compra Exactas —{' '}
                <span style={{
                color: 'var(--color-gold)'
              }} data-id="element-386">
                  Ahorrá 40%
                </span>
              </h3>
              <p className="text-sm leading-relaxed m-0" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-secondary)'
            }} data-id="element-387">
                Comprás las cantidades justas.{' '}
                <strong data-id="element-388">Cero desperdicio, cero compras de impulso.</strong>{' '}
                Nuestros usuarios ahorran hasta un{' '}
                <span style={{
                textDecoration: 'underline',
                textDecorationColor: 'var(--color-gold)',
                textUnderlineOffset: '3px'
              }} data-id="element-389">
                  40% en el supermercado
                </span>{' '}
                comparado con su gasto anterior.
              </p>
            </div>
          </div>

          {/* Feature 3 */}
          <div className="feature-card overflow-hidden flex flex-col p-0" style={{
          borderRadius: '1rem'
        }} data-id="element-390">
            {/* Image area */}
            <div className="w-full overflow-hidden" style={{
            borderRadius: '1rem 1rem 0 0'
          }} aria-label="Imagen módulo 3" data-id="element-391">
              <img src="https://cdn.magicpatterns.com/uploads/6VpwmbnkvR1152DL8Zg8Dc/20260303_0948_Image_Generation_simple_compose_01kjsvtsdye4w928z3t6wb5cns_(1).webp" alt="Sistema 10x2™ — Piloto Automático + Auditoría de Freezer" className="w-full object-cover" style={{
              display: 'block',
              maxHeight: '200px',
              objectPosition: 'center'
            }} data-id="element-392" />
            </div>
            {/* Content */}
            <div className="p-5" data-id="element-393">
              <h3 className="text-base mb-1.5" style={{
              fontFamily: 'var(--font-heading)',
              fontWeight: 600,
              color: 'var(--text-primary)',
              letterSpacing: '-0.01em'
            }} data-id="element-394">
                <span style={{
                textDecoration: 'underline',
                textDecorationColor: 'var(--color-gold)',
                textUnderlineOffset: '3px'
              }} data-id="element-395">
                  Piloto Automático
                </span>{' '}
                + Auditoría de Freezer
              </h3>
              <p className="text-sm leading-relaxed m-0" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-secondary)'
            }} data-id="element-396">
                <em data-id="element-397">Funciona incluso cuando NO tenés ganas.</em> La comida ya
                está lista: calentás y servís. Sabés qué hay en el freezer, qué
                consumir primero y qué reponer. <strong data-id="element-398">Cero sorpresas.</strong>
              </p>
            </div>
          </div>
        </div>

        {/* Compatibility */}
        <div className="rounded-2xl p-5 md:p-6 mb-8" style={{
        background: '#FAF5E8',
        border: '1px solid rgba(184,146,42,0.15)'
      }} data-id="element-399">
          <p className="eyebrow text-center mb-4" style={{
          color: 'var(--color-gold)'
        }} data-id="element-400">
            Funciona para todos
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5" data-id="element-401">
            <div className="flex items-start gap-2.5" data-id="element-402">
              <span className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold text-white mt-0.5" style={{
              background: 'var(--color-gold)'
            }} data-id="element-403">
                ✓
              </span>
              <div data-id="element-404">
                <p className="font-bold text-sm m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-primary)'
              }} data-id="element-405">
                  Cualquier nivel
                </p>
                <p className="text-xs m-0 mt-0.5" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }} data-id="element-406">
                  Si sabés prender el horno, podés usar esto.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-2.5" data-id="element-407">
              <span className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold text-white mt-0.5" style={{
              background: 'var(--color-gold)'
            }} data-id="element-408">
                ✓
              </span>
              <div data-id="element-409">
                <p className="font-bold text-sm m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-primary)'
              }} data-id="element-410">
                  Cualquier presupuesto
                </p>
                <p className="text-xs m-0 mt-0.5" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }} data-id="element-411">
                  Ahorrás hasta 40% vs. lo que gastás hoy.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-2.5" data-id="element-412">
              <span className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold text-white mt-0.5" style={{
              background: 'var(--color-gold)'
            }} data-id="element-413">
                ✓
              </span>
              <div data-id="element-414">
                <p className="font-bold text-sm m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-primary)'
              }} data-id="element-415">
                  Cualquier cocina
                </p>
                <p className="text-xs m-0 mt-0.5" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }} data-id="element-416">
                  Funciona con lo que ya tenés en casa.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Mid-page CTA */}
        <div data-id="element-417">
          {/* Price card */}
          <div className="rounded-2xl p-7 text-center mb-4" style={{
          background: 'var(--bg-surface)',
          border: '1px solid var(--border-default)',
          boxShadow: 'var(--shadow-sm)'
        }} data-id="element-418">
            <p className="eyebrow mb-4" data-id="element-419">Precio de oferta:</p>
            <p className="text-2xl line-through mb-1" style={{
            fontFamily: 'var(--font-body)',
            color: 'var(--text-muted)'
          }} data-id="element-420">
              $87.995 ARS
            </p>
            <p className="text-5xl font-bold mb-4" style={{
            fontFamily: 'var(--font-heading)',
            color: 'var(--color-primary)',
            lineHeight: 1.1,
            letterSpacing: '-0.02em'
          }} data-id="element-421">
              $19.999 ARS
            </p>
            <p className="text-sm m-0" style={{
            fontFamily: 'var(--font-body)',
            color: 'var(--text-muted)'
          }} data-id="element-422">
              Pago único · Sin suscripciones · Sin cargos ocultos
            </p>
          </div>
          {/* Gold CTA — outside the card */}
          <a href={CART_URL} className="btn-cta-gold btn-cta-gold-pulse w-full text-base md:text-lg px-6 py-4 rounded-xl mb-2 block text-center" data-id="element-423">
            QUIERO MI SISTEMA &gt;&gt;
          </a>
          <p className="text-sm text-center" style={{
          fontFamily: 'var(--font-body)',
          color: 'var(--color-accent)'
        }} data-id="element-424">
            ✓ Descarga inmediata de todo el paquete
          </p>
        </div>
      </div>
    </section>;
}